import React, { useEffect, useState } from 'react';
import { updateProfile } from 'firebase/auth';
import { auth, db } from '../utils/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import AccountLayout from '../components/AccountLayout';

const inputCls = "w-full border border-border rounded-xl px-4 py-3 focus:outline-none focus:border-ring text-foreground placeholder:text-[var(--color-muted-foreground)] bg-card text-sm transition-colors";
const labelCls = "block text-xs font-bold text-[var(--color-muted-foreground)] uppercase tracking-wider mb-1.5";

export default function AccountSettings() {
  const user = auth.currentUser;
  const [displayName,  setDisplayName]  = useState(user?.displayName || '');
  const [phoneNumber,  setPhoneNumber]  = useState('');
  const [message,      setMessage]      = useState('');
  const [isError,      setIsError]      = useState(false);
  const [loading,      setLoading]      = useState(false);

  useEffect(() => {
    if (!user?.uid) return;
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'users', user.uid));
        if (snap.exists()) setPhoneNumber(snap.data().phoneNumber || '');
      } catch { setMessage("Unable to load account info."); setIsError(true); }
    })();
  }, [user?.uid]);

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true); setMessage('');
    try {
      await updateProfile(user, { displayName });
      await setDoc(doc(db, 'users', user.uid), { phoneNumber }, { merge: true });
      setMessage('Account updated successfully!'); setIsError(false);
    } catch (err) {
      setMessage(`Error: ${err.message}`); setIsError(true);
    } finally { setLoading(false); }
  };

  return (
    <AccountLayout title="Account Settings">
      <div className="max-w-lg">
        {message && (
          <div className={`mb-6 px-4 py-3 rounded-xl text-sm border ${isError ? "bg-red-50 border-red-200 text-red-700 dark:bg-red-950/30 dark:border-red-900/50 dark:text-red-400" : "bg-green-50 border-green-200 text-green-700 dark:bg-green-950/30 dark:border-green-900/50 dark:text-green-400"}`}>
            {message}
          </div>
        )}
        <div className="bg-card rounded-2xl border border-border shadow-sm p-7">
          <form onSubmit={handleSave} className="space-y-5">
            <div>
              <label className={labelCls}>Display Name</label>
              <input type="text" className={inputCls} placeholder="Your name" value={displayName} onChange={e => setDisplayName(e.target.value)} />
            </div>
            <div>
              <label className={labelCls}>Phone Number</label>
              <input type="tel" className={inputCls} placeholder="2145551234" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} />
            </div>
            <div>
              <label className={labelCls}>Email Address</label>
              <input type="email" className={`${inputCls} bg-muted cursor-not-allowed opacity-70`} value={user?.email || ''} readOnly />
              <p className="text-xs text-[var(--color-muted-foreground)] mt-1">Contact support to change your email address.</p>
            </div>
            <button type="submit" disabled={loading} className="w-full bg-brand-navy hover:bg-brand-amber disabled:opacity-50 transition-colors text-white font-bold py-3.5 rounded-xl">
              {loading ? "Saving…" : "Save Changes"}
            </button>
          </form>
        </div>
      </div>
    </AccountLayout>
  );
}
